import * as Yup from "yup";

import React, { Fragment } from "react";

import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import Progresso from "../../components/Progresso";
import Titulo from "../../components/Titulo";
import translate from "../../i18n";
import { useFormik } from "formik";

interface Props {
  nextStep?: Function;
}

const BoasVindas: React.FC<Props> = ({ nextStep }) => {
  const [onMouseEnterItem, setOnMouseEnterItem] = React.useState([
    false,
    false,
    false,
  ]);

  const formik = useFormik({
    initialValues: {
      radioParticipante: "",
    },
    validationSchema: Yup.object({
      radioParticipante: Yup.string().required(
        translate.t("app.tela.boasVindas.mensagem.validacaoSelecaoParticipante")
      ),
    }),

    onSubmit: (values) => {
      if (nextStep) {
        sessionStorage.setItem(
          "@RealizePrev:tipoParticipante",
          values.radioParticipante
        );
        nextStep();
        window.scrollTo(0, 0);
      }
    },
  });

  return (
    <Fragment>
      <form onSubmit={formik.handleSubmit}>
        <main>
          <div className="wrapper">
            <div className="intro">
              <div className="left">
                <h2>Solicitação de adesão ao Plano</h2>
                <p>
                  <strong style={{ color: "black" }}>
                    {translate.t("app.tela.boasVindas.tituloDescricao")}
                  </strong>
                  {translate.t("app.tela.boasVindas.descricao1")}
                </p>
                <p>{translate.t("app.tela.boasVindas.descricao2")}</p>
              </div>

              <div className="right">
                <h3>
                  {" "}
                  {translate.t("app.tela.boasVindas.label.escolhaOpcao")}
                </h3>
                <ul>
                  <li
                    style={{
                      display: "flex",
                    }}
                  >
                    <label
                      style={{
                        borderColor:
                          onMouseEnterItem[0] ||
                          formik.values.radioParticipante === "Participante"
                            ? "#ffc23e"
                            : "white",
                        backgroundColor:
                          onMouseEnterItem[0] ||
                          formik.values.radioParticipante === "Participante"
                            ? "#ffc23e"
                            : "",
                      }}
                      className="custom-radio"
                    />

                    <label
                      style={{
                        color:
                          onMouseEnterItem[0] ||
                          formik.values.radioParticipante === "Participante"
                            ? "#ffc23e"
                            : "white",
                      }}
                      className="wrap-checkbox"
                      onMouseEnter={() => {
                        setOnMouseEnterItem([true, false, false]);
                      }}
                      onMouseLeave={() => {
                        setOnMouseEnterItem([false, false, false]);
                      }}
                    >
                      {" "}
                      <strong>
                        {translate.t(
                          "app.tela.boasVindas.label.souParticipante"
                        )}
                      </strong>
                      <br />
                      {translate.t(
                        "app.tela.boasVindas.label.souParticipanteDesc"
                      )}
                      <input
                        type="radio"
                        name="radioParticipante"
                        value="Participante"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={
                          formik.values.radioParticipante === "Participante"
                        }
                      />
                      {/* <span className="check"></span> */}
                    </label>
                  </li>

                  <li
                    style={{
                      display: "flex",
                    }}
                  >
                    <label
                      className="custom-radio"
                      style={{
                        borderColor:
                          onMouseEnterItem[1] ||
                          formik.values.radioParticipante ===
                            "ParenteParticipante"
                            ? "#ffc23e"
                            : "white",
                        backgroundColor:
                          onMouseEnterItem[1] ||
                          formik.values.radioParticipante ===
                            "ParenteParticipante"
                            ? "#ffc23e"
                            : "",
                      }}
                    />

                    <label
                      style={{
                        color:
                          onMouseEnterItem[1] ||
                          formik.values.radioParticipante ===
                            "ParenteParticipante"
                            ? "#ffc23e"
                            : "white",
                      }}
                      className="wrap-checkbox"
                      onMouseEnter={() => {
                        setOnMouseEnterItem([false, true, false]);
                      }}
                      onMouseLeave={() => {
                        setOnMouseEnterItem([false, false, false]);
                      }}
                    >
                      {" "}
                      <strong>
                        {translate.t(
                          "app.tela.boasVindas.label.souParenteParticipante"
                        )}
                      </strong>
                      <br />
                      <input
                        type="radio"
                        value="ParenteParticipante"
                        name="radioParticipante"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={
                          formik.values.radioParticipante ===
                          "ParenteParticipante"
                        }
                      />
                      {/* <span className="check"></span> */}
                    </label>
                  </li>

                  <li
                    style={{
                      display: "flex",
                    }}
                  >
                    <label
                      className="custom-radio"
                      style={{
                        borderColor:
                          onMouseEnterItem[2] ||
                          formik.values.radioParticipante ===
                            "AssociadoEspecial"
                            ? "#ffc23e"
                            : "white",
                        backgroundColor:
                          onMouseEnterItem[2] ||
                          formik.values.radioParticipante ===
                            "AssociadoEspecial"
                            ? "#ffc23e"
                            : "",
                      }}
                    />

                    <label
                      style={{
                        color:
                          onMouseEnterItem[2] ||
                          formik.values.radioParticipante ===
                            "AssociadoEspecial"
                            ? "#ffc23e"
                            : "white",
                      }}
                      className="wrap-checkbox"
                      onMouseEnter={() => {
                        setOnMouseEnterItem([false, false, true]);
                      }}
                      onMouseLeave={() => {
                        setOnMouseEnterItem([false, false, false]);
                      }}
                    >
                      {" "}
                      <strong>
                        {translate.t(
                          "app.tela.boasVindas.label.souAsociadoEspecial"
                        )}
                      </strong>
                      <br />
                      {translate.t(
                        "app.tela.boasVindas.label.souAsociadoEspecialDesc"
                      )}
                      <input
                        type="radio"
                        value="AssociadoEspecial"
                        name="radioParticipante"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={
                          formik.values.radioParticipante ===
                          "AssociadoEspecial"
                        }
                      />
                      {/* <span className="check"></span> */}
                    </label>
                  </li>

                  <Error error={formik.errors.radioParticipante} />
                </ul>
              </div>
            </div>
          </div>
        </main>

        <div className="membership__pagination text-center mt-3">
          <Button avancar previousStep={() => {}} />
        </div>
      </form>
    </Fragment>
  );
};
export default BoasVindas;
